<template>
    <v-card>
        <v-card-title class="headline primary white--text text-uppercase text-body-1 pa-6">
            Newsletter Notification
        </v-card-title>

        <v-card-text>
            You have new newsletter available <br>
            <a @click.stop="goToNewsletter" >View now</a>
        </v-card-text>

        <v-card-actions>
            <v-btn @click="confirmNotificationShown">Okay</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters('auth', [
            'user',
        ]),
    },

    methods: {
        ...mapActions('auth', ['updateUserData']),
        goToNewsletter() {
            this.confirmNotificationShown().then(() => {
                this.$router.push({name: 'Newsletters'})
            })
        },
        confirmNotificationShown() {
            return this.updateUserData({seen_latest_newsletter: true});
        }
    }
}
</script>
